import React from 'react';
import styled from 'styled-components';
import { Grid } from '@mui/material';
import { type AdditionalDocFormsProps } from './types';
import { AdditionalDocumentForm } from './AdditionDocumentForm';
import { PAGE_COMMON_TEXT } from '../../lang';

export const AdditionalDocumentForms: React.FunctionComponent<
  AdditionalDocFormsProps
> = (props: AdditionalDocFormsProps) => {
  const additionalDocuments = props.data ?? [];
  const hasAdditionalDocuments = additionalDocuments.length > 0;

  return hasAdditionalDocuments ? (
    <Container>
      <Grid container spacing={2} padding={1}>
        {additionalDocuments.map((additionalDocument, index) => {
          return (
            <AdditionalDocumentForm key={index} data={additionalDocument} />
          );
        })}
      </Grid>
    </Container>
  ) : (
    <div>{PAGE_COMMON_TEXT.NA}</div>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 1rem 0 0 0;

  .MuiGrid-item {
    padding-left: 0 !important;
  }

  .MuiGrid-container {
    padding: 0.5rem 1rem 0 2rem !important;
  }
`;
